module.exports = __webpack_public_path__ + "static/media/RasterText_GET@3x.e93514dd.png";